import { withRouter } from 'react-router';
import { withUser } from 'components/queries/GetUserQuery';

import GenerateQRCodesCta from './GenerateQRCodesCta';

export default withRouter(withUser(GenerateQRCodesCta));
